/**
 * This enum is used to store the timezone string for formatting dates in listed timezones.
 * If we need to add more timezones in the future, we can simply add them to this enum and use them throughout the application.
 * Follow the naming from {@link https://en.wikipedia.org/wiki/List_of_tz_database_time_zones}
 */
export enum DateTimeZone {
  America_Sao_Paulo = 'America/Sao_Paulo',
  UTC = 'UTC',
}
